const BASE_API = process.env.REACT_APP_BASE_API || 'http://localhost:3000';

const apiUrl = `${BASE_API}/api/v1`;

let finished = false;

export const surveyApi = {
  finish: async (userId, answers) => {
    if(finished == true) return;
    finished = true;
    const payload = {
      userId,
      answers,
    };
    const response = await fetch(`${apiUrl}/survey/finish`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    return response.json();
  },

  welcome: async (screenType) => {
    const payload = {
      screenType,
    };
    const response = await fetch(`${apiUrl}/survey/welcome`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    finished = false;
    return response.json();
  },

  share: async (userId, platform) => {
    const payload = {
      userId,
      platform,
    };

    const response = await fetch(`${apiUrl}/survey/share`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    return response.json();
  },

  screenshot: async (uid) => {
    const response = await fetch(`${apiUrl}/survey/screenshot?uid=${uid}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.json();
  },
};
